const ProtocalType_S2C = {};

ProtocalType_S2C.AUTH = "AUTH";// 权限
ProtocalType_S2C.FORCE_LOGIN_OUT_C = "FORCE_LOGIN_OUT_C";// 物理连接被强制登出
ProtocalType_S2C.ACK = "ACK";// ack应答包

ProtocalType_S2C.M1_C = "M1_C";//日常咨询消息(相互发送)(客服-->顾客)
ProtocalType_S2C.M2 = "M2";//通知顾客：无机器人或无效回答
ProtocalType_S2C.N1_C = "N1_C";// 消息状态变更
ProtocalType_S2C.N3 = "N3";// 邀请评价
ProtocalType_S2C.S1 = "S1";// 系统消息包
ProtocalType_S2C.S3 = "S3";// 系统消息包
ProtocalType_S2C.L2 = "L2";// 提醒顾客留言(系统发送给顾客)
ProtocalType_S2C.C1 = "C1";// 关闭会话通知顾客C1
ProtocalType_S2C.C1_CO = "C1_CO";// 关闭会话通知顾客--客户超时回复
ProtocalType_S2C.C1_UO = "C1_UO";// 关闭会话通知顾客--客服超时回复
ProtocalType_S2C.T3 = "T3";//  接受转接通知顾客端变更会话ID

export default ProtocalType_S2C;
